export default __webpack_public_path__ + "static/terpesona-30e3c62e0f9fbecca866c5bad0cfe996.mp4";